import AppPopover from "@/components/AppPopover";
export default {
  name: "PpcBAProductInfoCell",
  components: {
    AppPopover
  },
  props: {
    name: {
      type: String
    },
    image: {
      type: String
    },
    item_id: {
      type: String
    }
  }
};